<template>
  <div class="infoEdit">
    <bread :list="list"></bread>
    <!--  -->
    <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
      <el-form-item label="分享标题：">
        <el-input
          v-model="formLabelAlign.article_title"
          ref="article_title"
          data-tips="请输入分享标题"
          placeholder="请输入"
          maxlength="90"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="SEO标题：">
        <el-input
          v-model="formLabelAlign.seo_title"
          ref="seo_title"
          data-tips="请输入SEO标题"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="SEO关键词：">
        <el-input
          v-model="formLabelAlign.seo_keyword"
          ref="seo_keyword"
          data-tips="请输入SEO关键词"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="SEO描述：">
        <el-input
          type="textarea"
          rows="3"
          v-model="formLabelAlign.seo_describe"
          ref="seo_describe"
          data-tips="请输入SEO描述"
          placeholder="请输入一百字左右的SEO描述"
        ></el-input>
      </el-form-item>

      <el-form-item style="width: 36%;" label="分类：">
        <el-select v-model="formLabelAlign.category_id" ref="category_id" data-tips="请选择分类">
          <el-option
            v-for="(item,index) in options0"
            :label="item.name"
            :key="index"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="缩略图：" class="picbox">
        <el-upload
          v-model="formLabelAlign.thumb"
          accept="image/png, image/jpg, image/jpeg"
          ref="thumb"
          list-type="picture-card"
          data-tips="请上传缩略图"
          class="avatar-uploader"
          action=" http://glc.ilianpei.com/common/upload/image/qiniu"
          :http-request="myUpload"
          :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" size="tiny">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
        <!-- <enlargePic class="shili" :src="$shili_infoEdit" :imgSrc="[$shili_infoEdit]"></enlargePic> -->
      </el-form-item>
      <el-form-item label="摘要：">
        <el-input
          type="textarea"
          rows="3"
          v-model="formLabelAlign.abstract"
          ref="abstract"
          data-tips="请输入摘要"
          placeholder="请输入一百字左右的摘要"
        ></el-input>
      </el-form-item>
      <el-form-item label="详情：">
        <div class="bianji">
          <input
            type="file"
            @change="update"
            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .PBG"
            ref="contentUpload"
            id="avatar-uploader"
          />
          <i class="iconfont icon-htmal5icon12"></i>
        </div>
        <quill-editor
          v-model="formLabelAlign.content"
          ref="content"
          class="quill"
          data-tips="请输入详情"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        ></quill-editor>
        <!-- <el-input  type="hidden" v-model="formLabelAlign.content"   placeholder="请输入" ></el-input> -->
      </el-form-item>
      <el-form-item size="large" class="text-center margin-top-50">
        <el-button class="btn1" type="primary" @click="onSubmit">确认提交</el-button>
        <el-button class="btn2" @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
    <!-- <enlarge-pic class="shili" :src="$shili" :imgSrc="[$shili]" ></enlarge-pic> -->
  </div>
</template>

<script>
import bread from "../../../components/bread.vue";
// import enlargePic from "../../../components/enlargePic.vue";
const toolbarOptions = {
  modules: {
    ImageExtend: {
      // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
      name: "img", // 图片参数名
      size: 1, // 可选参数 图片大小，单位为M，1M = 1024kb
      response: res => {
        return res.data.url;
      },
      headers: xhr => {}
    },
    toolbar: {
      container: [
        ["bold", "italic"], //加粗，斜体，
        [{ size: ["small", false, "large", "huge"] }], // 字体大小
        [{ color: [] }], // 字体颜色，字体背景颜色
        [{ align: [] }] //对齐方式
      ],
      handlers: {
        image: function(value) {
          //劫持quill自身的文件上传，用原生替换
          if (value) {
            document.querySelector("#avatar-uploader").click();
          } else {
            this.quill.format("image", false);
          }
        }
      }
    }
  }
};
export default {
  components: {
    bread
  },
  data() {
    return {
      addShow: true,
      labelPosition: "right",
      formLabelAlign: {
        token: window.localStorage.getItem("pc_token"),
        article_title: "", //资讯文章标题
        category_id: "", //资讯分类id
        thumb: "", //缩略图
        abstract: "", //摘要
        content: "", //详情
        seo_title: "", //seo标题
        seo_keyword: "", //seo关键字
        seo_describe: "" //seo描述

        // formContent: {
        //   Body: ""
        // },
        // picList: [],
        // actionUrl: 0,
        // imgUrl: ""
      },
      options0: [], //分类
      list: [
        {
          title: "信息管理"
        },
        {
          title: "资讯管理"
        },
        {
          title: "资讯添加、编辑"
        }
      ],
      imageUrl: "",
      editorOption: {
        placeholder: "请输入",
        toolbarOptions
      }, // 富文本配置 文本编辑器
      isDisabled: true,
      dialogImageUrl:
        "http://img.ilianpei.com/2020-07-06/15940187615f02cbc990b9a.png",
      dialogVisible: false,
      isEdit: false //判断是编辑还是添加
    };
  },
  created() {
    this.infoCategory(); //资讯分类接口
    //判断是添加还是编辑
    if (this.$route.query.id) {
      this.formLabelAlign = JSON.parse(window.localStorage.getItem("infoData"));
      this.formLabelAlign.token = window.localStorage.getItem("pc_token");
      this.imageUrl = this.formLabelAlign.thumb;
      this.isEdit = true;
      this.list = [
        {
          title: "信息管理"
        },
        {
          title: "资讯管理"
        },
        {
          title: "资讯编辑"
        }
      ];
    } else {
      this.list = [
        {
          title: "信息管理"
        },
        {
          title: "资讯管理"
        },
        {
          title: "资讯添加"
        }
      ];
      this.isEdit = false;
      this.checkedNum(); //通过直接输入网址的形式进入发布页 发布新闻是否达到上限
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt1M = file.size / 1024 / 1024 < 0.05;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式!");
      }
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 50k!");
      }
      if (isJPG && isLt1M) {
        this.addShow = false;
      }
      return isJPG && isLt1M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.imageUrl = "";
      this.formLabelAlign.thumb = "";
    },
    update() {
      let inputDOM = this.$refs.contentUpload;
      this.file = inputDOM.files[0];
      let isJPG =
        this.file.type === "image/jpeg" || this.file.type === "image/png";
      let isLt1M = this.file.size / 1024 / 1024 < 0.15;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式!");
        return false;
      }
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 150k!");
        return false;
      }
      var formdata = new FormData();
      formdata.append(
        "file",
        document.getElementById("avatar-uploader").files[0]
      );
      formdata.append("type", 8);
      this.post(this, "/common/upload/image/qiniu", formdata).then(res => {
        this.imgUrl = res.data.url;
        let quill = this.$refs.content.quill;
        // const range = quill.getSelection();
        const range = quill.selection.savedRange;
        if (range) {
          quill.insertEmbed(range.index, "image", this.imgUrl);
        }
        // quill.setSelection(quill.getSelection().index + 1);
        quill.setSelection(quill.selection.savedRange.index + 1);
        this.$refs.contentUpload.value = null;
      });
    },
    checkedNum() {
      // 验证添加资讯文章数量接口
      this.post(this, "/home/checkNumber", {
        token: this.formLabelAlign.token
      }).then(res => {
        if (res.data.code != 0) {
          this.$router.go(-1);
        }
      });
    },
    // 资讯分类接口
    infoCategory() {
      this.post(this, "/home/infoCategory", {
        token: this.formLabelAlign.token
      }).then(res => {
        this.options0 = res.data.data;
      });
    },
    myUpload(content) {
      var formdata = new FormData();
      formdata.append("file", content.file);
      formdata.append("type", 4);
      this.axios
        .post(content.action, formdata, {
          onUploadProgress: progressEvent => {
            let num = ((progressEvent.loaded / progressEvent.total) * 100) | 0; //百分比
            content.onProgress({ percent: num }); //进度条
          }
        })
        .then(res => {
          content.onSuccess(res.data);
        });
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      this.formLabelAlign.thumb = res.url;
      this.imageUrl = res.url;
    },
    // 添加资讯文章
    onSubmit() {
      var params = this.formLabelAlign;
      if (
        this.isDisabled &&
        document.getElementsByClassName("el-message").length === 0
      ) {
        this.isDisabled = false;
        for (var item in params) {
          if (!params[item]) {
            if (
              item != "seo_title" &&
              item != "seo_keyword" &&
              item != "seo_describe"
            ) {
              this.$message.error(this.$refs[item].$attrs["data-tips"]);
              this.isDisabled = true;
              return false;
            }
          }
        }
        var url;
        if (this.isEdit) {
          //判断是编辑接口还是添加接口
          url = "/home/editArticle";
        } else {
          url = "/home/addInformation";
        }
        this.post(this, url, params).then(res => {
          if (res.data.code == 0) {
            this.$message.success(res.data.msg);
            this.$router.go(-1); //返回上一层
          }
          this.isDisabled = true;
        });
      }
    },
    onEditorReady(editor) {
      // 准备编辑器
    },
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange(e) {
      if (e.html.indexOf("&lt;a") >= 0 || e.html.indexOf("<a") >= 0) {
        this.formLabelAlign.content = this.formLabelAlign.content.replace(
          /(<\/?a.*?>)|(<\/?span.*?>)/g,
          ""
        );
      }
    } // 内容改变事件
  },
  computed: {
    editor() {
      return this.$refs.content.quill;
    }
  }
};
</script>
<style >
.picbox .el-form-item__content div.avatar-uploader,
.picbox .el-form-item__content div.avatar-uploader div {
  float: left;
  margin-right: 20px;
}
.picbox .shili {
  float: left;
  width: 122px;
  height: 122px;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  overflow: hidden;
}
.avatar-uploader .el-upload-list--picture-card .el-upload-list__item {
  width: 123px;
  height: 123px;
  border: 1px dashed #c0c4cc;
  text-align: center;
  line-height: 123px;
}
.avatar-uploader
  .el-upload-list__item.is-success
  .el-upload-list__item-status-label {
  display: none;
}

.infoEdit .ql-editor {
  height: 600px;
}
</style>
<style scoped>
form {
  width: 950px;
  padding: 50px 0 0;
}
.el-select {
  width: 100%;
}
.avatar-uploader {
  width: 123px;
  height: 123px;
  border: 1px dashed #c0c4cc;
  text-align: center;
  line-height: 123px;
  border-radius: 10px;
}
.avatar-uploader img {
  border-radius: 10px;
}
.avatar-uploader-icon {
  color: #333;
  font-size: 28px;
  line-height: 0;
}
.btn1,
.btn2 {
  width: 130px;
  border: none;
}
.btn1 {
  background-color: #ff7c00;
  color: #fff;
  margin-right: 30px;
}
.btn2 {
  background-color: #d2d2d2;
  color: #fff;
}

#avatar-uploader {
  position: relative;
  z-index: 3;
  opacity: 0;
  width: 18px;
}
.icon-htmal5icon12 {
  position: absolute;
  left: 0;
  z-index: 2;
  font-size: 18px;
}
.bianji {
  position: absolute;
  left: 216px;
  transform: translateY(140%);
}
.quill::after {
  content: "提示：文章内上传图片为jpg或png格式，单张图片最大为150k";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(105%);
  color: #606266;
  font-size: 14px;
  line-height: 40px;
}
.avatar-uploader::after {
  content: "提示： 上传图片建议最大为50k";
  display: block;
  position: absolute;
  right: 50%;
  top: 0;
  /* transform: translateX(-230%); */
  color: #606266;
  font-size: 14px;
  line-height: 40px;
}
</style>
<style>
.avatar-uploader .el-upload {
  width: 121px;
  height: 121px;
  line-height: 121px;
}
.avatar-uploader .el-upload img {
  width: 120px;
  height: 120px;
}
.infoEdit .ql-link {
  display: none !important;
}
/* .el-progress__text {
    transform: translate(180%, 200%) !important;
} */
.infoEdit textarea {
  height: auto;
  resize: none;
  overflow: auto;
}
</style>
